import { Box, HStack, Text } from '@chakra-ui/react'
import React from 'react'
import { Link, useMatch } from 'react-router-dom'

const SidebarLink = ({ name, path, icon, onClick, defaultBackgroundColor = 'teal.500' }) => {
  if (path) {
    const selected = useMatch(path)

    return (
      <Link to={path} style={{ textDecoration: 'none' }}>
        <Box
          w="100%"
          px={5}
          py={3}
          _hover={{ bg: 'teal.600', cursor: 'pointer', color: 'white' }}
          bg={selected ? 'teal.600' : defaultBackgroundColor}
          color={selected ? 'white' : ''}
        >
          <HStack>
            {icon}
            <Text fontSize="md">{name}</Text>
          </HStack>
        </Box>
      </Link>
    )
  } else {
    const selected = ''
    return (
      <Link style={{ textDecoration: 'none' }} onClick={onClick}>
        <Box
          w="100%"
          px={5}
          py={3}
          _hover={{ bg: 'teal.600', cursor: 'pointer', color: 'white' }}
          bg={selected ? 'teal.600' : ''}
          color={selected ? 'white' : ''}
        >
          <HStack>
            {icon}
            <Text fontSize="md">{name}</Text>
          </HStack>
        </Box>
      </Link>
    )
  }
}

export default SidebarLink
